/* eslint-disable @typescript-eslint/no-explicit-any */
export const omitObjectKey = (obj: any, key: string) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { [key]: _, ...rest } = obj
  return rest
}
